export class TasksVO {
  constructor(
        public user?: any,
        public providerId?: any,
        public tasksList?: any,
        public areaCode?: any,
        public countyArray?: string[],
        public seriesInfoList?: any,
        public seriesInfoList2?: any,
        public taskCount?: any,
        public opentasksList?: any,
        public pendingtasksList?: any,
        public inProgresstasksList?: any,
        public messagesList?:any,
        public todayAppointmentList?:any,
        public tomorrowAppointmentList?:any,
        public missedAppointmentList?:any,
        public allAppointmentList?:any,
        public wpEtEnrollmentNullList?:any,
        public wpEtEnrollmentNotNullList?:any,
        public pendingCoList?:any,
        public providerList?: any,
	    public county?: any,
        public provider?: any,
        public participation?: any,
	    public reportBeginDate?: any,
	    public reportEndDate?: any,
        public countyList?: any,
        public taskTypeList?: any,
        public taskType?: any,
        public componentVOList?: any,
        public providerStringList?: any,
        public  countyOutput?: any,
        public  providerOutput?: any,
        public  clientSearch?: any,
        public report?: any,
        public reportNameOutput?: any,
        public clientSearchOutput?: any,
        public providerFinalList?: any,
        public assessmentDataVOList?: any,
        public countyFinalList?: any,
        public beginDatePeriod?: any,
        public endDatePeriod?:any,
        public periodList?:any,
        public participationTypes?:any,
    ) {
    }
}

export class EmploymentTrainingRetentionRequest {
  constructor(
        public areaCode?: any,
        public county?: any,
        public provider?: any,
        public participationType?: any,
	    public reportBeginDate?: any,
	    public reportEndDate?: any,
        public report?: any,
        public role?: any,
    ) {
    }
}

export class PyramidVO {
  constructor(
        public reportTitle?:string,
        public totalPopulationSection?:SectionVO,
        public appointmentSection?:any,
        public assesmentSection?:any,
        public employmentplanSection?:any,
        public componentsSection?:any,
        public employmentSection?:any,
        public areaCode?: any,
        public county?: any,
        public provider?: any,
        public participationType?: any,
	    public reportBeginDate?: any,
	    public reportEndDate?: any,
        public report?: any,
    ) {
    }
}

export class SectionVO {
    constructor(  
        public sectionTitle?:string,
        public totalNumber?:number,
        public percent?:number,
    ) {
     
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/model/reports-summary.model.ts